import { render, staticRenderFns } from "./productSales.vue?vue&type=template&id=2fab934f&scoped=true&"
import script from "./productSales.vue?vue&type=script&lang=js&"
export * from "./productSales.vue?vue&type=script&lang=js&"
import style0 from "./productSales.vue?vue&type=style&index=0&id=2fab934f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab934f",
  null
  
)

export default component.exports